/*
 * Gallery Section
 */
'use strict';

jQuery($ => {
    $('.gecko-builder-gallery-section__container').each((i, el) => {
        const swiperContainer = $(el).find('.swiper-container');
        const mySwiper = new Swiper(swiperContainer, {
            slidesPerView: 4,
            spaceBetween: 32,
            breakpoints: {
                540: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                }
            },
            navigation: {
                prevEl: '.gecko-builder-gallery-item__nav-item--prev',
                nextEl: '.gecko-builder-gallery-item__nav-item--next'
            }
        });
    });
});
